import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { s3baseUrl } from "src/config/config";
import { htmlDecode } from "src/utils/convertHtml";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import RecordNotFound from "src/components/RecordNotFound";
import { ExerciseListingApi } from "src/DAL/exercise/exercise";
import InfiniteScroll from "react-infinite-scroll-component";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer";
import ExerciseFilter from "./ExerciseFilterNew";
import { Icon } from "@iconify/react";
import roundFilterList from "@iconify/icons-ic/round-filter-list";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

function ToshowExercise({ open, setOpen, handleChange }) {
  const handleCloseDialog1 = () => {
    setOpen(false);
  };
  const classes = useStyles();
  const [exercise, setExercise] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filterName, setFilterName] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const [filterCount, setFilterCount] = useState(0);

  const EMPTY_FILTER = {
    exercises: [],
    mainMuscle: [],
    difficulty: [],
    search_text: "",
  };

  const [filterState, setFilterState] = useState(EMPTY_FILTER);
  const [filterStateUpdated, setFilterStateUpdated] = useState({});

  const searchFunction = () => {
    setPage(0);
    filterState.search_text = filterName;
    getExerciseList(filterState);
    localStorage.setItem(
      "WorkoutExerciseListSearch",
      JSON.stringify(filterState),
    );

    handleCloseFilterDrawer();
    setIsLoading(true);
  };

  const handleScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    if (scrollTop + clientHeight === scrollHeight) {
      fetchMoreData();
    }
  };

  const handleClearFilter = () => {
    let clear_data = { ...EMPTY_FILTER };
    setPage(0);
    setFilterName("");
    setFilterState(clear_data);
    getExerciseList(clear_data);
    handleCloseFilterDrawer();
    setIsLoading(true);
    localStorage.removeItem("WorkoutExerciseListSearch");
  };
  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
    setFilterState(filterStateUpdated);
  };
  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };
  const handleSelectExercise = (value) => {
    handleChange(value);
    handleCloseDialog1();
  };

  const fetchMoreData = () => {
    setRowsPerPage((prev) => prev + 50);
  };

  const getExerciseList = async (filterData) => {
    let postdata = {
      difficulty: filterData.difficulty,
      exercise: filterData.exercises,
      main_muscle: filterData.mainMuscle,
    };
    let result = await ExerciseListingApi(
      page,
      rowsPerPage,
      filterName,
      postdata,
    );
    if (result.code == 200) {
      setFilterCount(
        filterData?.difficulty.length +
          filterData?.exercises.length +
          filterData?.mainMuscle.length,
      );
      let chipData = { ...filterData };
      if (chipData.search_text) {
        delete chipData.search_text;
      }
      setFilterStateUpdated(chipData);
      setIsLoading(false);
      setExercise(result?.exercises);
      setTotalCount(result.total_exercises);
    }
  };
  useEffect(() => {
    if (open) {
      setExercise([]);
      let filter_data = EMPTY_FILTER;
      let find_filter = localStorage.getItem("WorkoutExerciseListSearch");
      if (find_filter) {
        filter_data = JSON.parse(find_filter);
        if (filter_data.search_text) {
          setFilterName(filter_data.search_text);
        }
      }
      setFilterState(filter_data);
      setFilterStateUpdated(filter_data);

      getExerciseList(filter_data);
    }
  }, [page, rowsPerPage, filterName, open]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseDialog1}
        fullWidth
        maxWidth="md"
        PaperProps={{
          style: {
            backgroundColor: "white",
            color: "black",
            boxShadow: "none",
            minHeight: "550px",
          },
        }}
      >
        <div className="d-flex justify-content-between align-items-center ">
          <div className="row w-100  ">
            <div className="col-lg-3 col-md-3 col-sm-12">
              <DialogTitle> Exercises</DialogTitle>
            </div>
            <div className="col-lg-9 col-md-9 col-sm-12">
              <div className=" me-1">
                <div className="text-end ">
                  <TextField
                    fullWidth
                    size="small"
                    label="Search"
                    sx={{ marginRight: 1, width: 240, mt: 3 }}
                    value={filterName}
                    onChange={(e) => setFilterName(e.target.value)}
                  />
                  <button
                    className="small-contained-button me-2  mt-4 mb-4"
                    onClick={handleOpenFilterDrawer}
                    style={{ position: "relative" }}
                  >
                    Filters &nbsp;&nbsp; <Icon icon={roundFilterList} />
                    <span
                      // className="small-contained-button"
                      style={{
                        position: "absolute",
                        bottom: "61%",
                        right: "8%",
                      }}
                    >
                      {filterCount ? (
                        <div className="dot-filter-count">{filterCount}</div>
                      ) : (
                        <div></div>
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DialogContent onScroll={handleScroll}>
          {isLoading ? (
            <CircularProgress className={classes.loading} color="primary" />
          ) : (
            <div className="">
              <CustomDrawer
                isOpenDrawer={filterDrawerState}
                onOpenDrawer={handleOpenFilterDrawer}
                onCloseDrawer={handleCloseFilterDrawer}
                pageTitle="Filters"
                componentToPassDown={
                  <ExerciseFilter
                    filterData={filterState}
                    setFilterData={setFilterState}
                    searchSubmitFilter={searchFunction}
                    handleClearFilter={handleClearFilter}
                  />
                }
              />
              <div className="row">
                {exercise.length < 1 ? (
                  <RecordNotFound title="Exercises" />
                ) : (
                  <InfiniteScroll
                    className="w-100 m-auto"
                    dataLength={exercise.length}
                    next={fetchMoreData}
                    hasMore={exercise.length < totalCount ? true : false} // Set this to 'false' when you have loaded all available data.
                    loader={<h4 className="text-center">Loading...</h4>}
                  >
                    <div className="row w-100 m-auto">
                      {exercise.map((x, i) => {
                        return (
                          <>
                            <div
                              className="col-lg-3 col-md-3 col-sm-12 mb-4"
                              key={i}
                              onClick={() => handleSelectExercise(x)}
                            >
                              <div className="card mt-1 exercise-cards-shadow ms-1 cursor h-100">
                                <img
                                  src={s3baseUrl + x?.image?.thumbnail_1}
                                  className="card-img-top pods-image"
                                  alt="workout"
                                />
                                <div className="card-body">
                                  <div className="row d-flex align-items-end h-100">
                                    <div className="col-12 ">
                                      <div className="h2-heading fw-bold ">
                                        {htmlDecode(x?.title)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </InfiniteScroll>
                )}
              </div>
            </div>
          )}
        </DialogContent>

        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
}

export default ToshowExercise;
